import type { IBreadcrumbsNav } from "@/lib/shared/types/breadcrumbs";

export const supportedCategories = ["new", "sales"] as const;
export const supportedSubcategories = ["bracelets", "necklaces", "earrings", "rings"] as const;
export type SupportedCategory = (typeof supportedCategories)[number];
export type SupportedSubcategory = (typeof supportedSubcategories)[number];

const categoryQueryLabelMap: Record<SupportedCategory, string> = {
  new: "new",
  sales: "sales",
};

export function isSupportedCategory(value: string): value is SupportedCategory {
  return supportedCategories.includes(value as SupportedCategory);
}

export function isSupportedSubcategory(value: string): value is SupportedSubcategory {
  return supportedSubcategories.includes(value as SupportedSubcategory);
}

export function getCategoryQueryLabels(
  category: SupportedCategory,
  subcategory?: SupportedSubcategory,
): string[] {
  return [categoryQueryLabelMap[category], ...(subcategory ? [subcategory] : [])];
}

export function buildCategoryMetadataTitle(
  categoryTitle: string,
  subcategoryTitle?: string,
): string {
  return subcategoryTitle ? `${categoryTitle} ${subcategoryTitle}` : categoryTitle;
}

export function buildCategoryBreadcrumbs(
  category: SupportedCategory,
  subcategory: SupportedSubcategory,
): IBreadcrumbsNav {
  return {
    level1: "products",
    level1Href: "/products",
    level2: category,
    level2Href: `/products/categories/${category}`,
    current: subcategory,
  };
}

/** Maps Payload label keys from the home categories section to an existing storefront listing path (locale prefix not included). */
export function getHomeCategoryListingPath(labelKey: string): string {
  if (labelKey === "new") {
    return "/products/categories/new";
  }
  if (labelKey === "sales") {
    return "/products/categories/sales";
  }
  if (labelKey === "jewellery") {
    return "/products/jewellery";
  }
  if (isSupportedSubcategory(labelKey)) {
    return `/products/jewellery/${labelKey}`;
  }
  return "/products";
}
